"use client";
import styled from "styled-components";
import InnerBanner from "@/components/InnerBanner";
import AboutOverview from "@/components/about/AboutOverview";
import MissionVision from "@/components/about/MissionVision";
import {useRouter} from "next/navigation";
import {useEffect} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ValueSlider from "@/components/about/ValueSlider";
import Leadership from "@/components/about/Leadership";
import Awards from "@/components/about/Awards";
import SisterConcern from "@/components/about/SisterConcern";
import {ScrollSmoother} from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


const AllAbout = ({data}) => {
    const getAboutData = data;
    const banner = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'inner_banner');
    const overview = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'about_overview');
    const team = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'team');
    const board_of_directors = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'board_of_directors');
    const sister = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'sister_concern');
    const mission_vision = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'mission_vision');
    const values = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'value_slider');
    const award = getAboutData?.data?.sections?.find(f=>f?.section_data?.template === 'award_slider');
    const router = useRouter();


    useEffect(() => {
        if (typeof window !== 'undefined' && window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            const topPx = targetElement?.offsetTop;
            if (targetElement) {
                gsap.to(window, {
                    duration: 0.8,
                    scrollTo: topPx
                });
            }
        }

    }, [typeof window !== 'undefined' && window.location.hash]);


    return (
        <StyledComponent>

            <InnerBanner
                text={banner?.section_data?.subtitle}
                img={banner?.images?.list?.[0]?.full_path}
            />
            <AboutOverview data={overview}/>
            <MissionVision data={mission_vision}/>
            {/*<ValueBackground/>*/}
            <ValueSlider data={values}/>
            <Leadership data={board_of_directors} padding={'pt-100'} id={'directors'}/>
            <Leadership  data={team} padding={'pb-100 pt-100'} id={'leaders'}/>
            {
                award?.posts?.list?.length > 0 &&
                <Awards data={award} />
            }

            <SisterConcern data={sister} id={'footprint'}/>
        </StyledComponent>
    );
};


const StyledComponent = styled.section`

`;

export default AllAbout;